import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { NvD3Module } from '../../widgets/nvd3';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MegaMenuComponent } from './topmenu/mega/mega.component';
import { NavSearchComponent } from './topmenu/navsearch/navsearch.component';

import { TourService } from './tour/tour.service';
import { TourButtonComponent } from './tour/tour.component';

// ngUpgrade Angular core services module
// Import converted service classes in ./services here
// Add to providers array, below
// Then go back to core.services.module.ajs.ts and register the downgraded service
import { BoardModule } from './board/board.module';
import { CoreWidgetsModule } from '../../widgets/core.widgets.module';
import { CoreFiltersModule } from '../core.filters.module';
import { CoreUserModule } from './user/core.user.module';
import { WikiModule } from '../../plugins/wiki/wiki.module';
import { SiteHelpModule } from './site-help/site-help.module';

import { FeedbackComponent } from './feedback/feedback.component';
import { GForgeFeedbackComponent } from './feedback/gforge-feedback.component';

import { FooterComponent } from './footer/footer.component';
import { ProjectBrowseComponent } from './project-browse/project-browse.component';

import { SearchComponent } from './search/search.component';
import { SiteSplashComponent } from './site-splash/site-splash.component';

import { TopMenuComponent } from './topmenu/topmenu/topmenu.component';

import { NotFoundComponent } from './home/not-found/not-found.component';
import { LicenseComponent } from './home/license/license.component';
import { ErrorBlockComponent } from './home/error-block/error-block.component';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        NvD3Module,
        NgbModule,
        NgSelectModule,
        FormsModule,
        CoreWidgetsModule,
        CoreFiltersModule,
        CoreUserModule,
        BoardModule,
        WikiModule,
        SiteHelpModule
    ],
    declarations: [
        FooterComponent,
        MegaMenuComponent,
        TourButtonComponent,
        NavSearchComponent,
        FeedbackComponent,
        GForgeFeedbackComponent,
        ProjectBrowseComponent,
        SearchComponent,
        SiteSplashComponent,
        TopMenuComponent,
        NotFoundComponent,
        LicenseComponent,
        ErrorBlockComponent,
    ],
    providers: [
        TourService,
        TourButtonComponent
    ],
    exports: [
        FooterComponent,
        MegaMenuComponent,
        TourButtonComponent,
        NavSearchComponent,
        FeedbackComponent,
        GForgeFeedbackComponent,
        ProjectBrowseComponent,
        SearchComponent,
        TopMenuComponent,
        SiteSplashComponent,
        CoreUserModule
    ]
})
export class CoreModules {
    constructor() { }
}
